import React from "react"
import DashboardVendas from "./dashboard/vendas/DashboardVendas"

const Dashboard = () => {
  return <DashboardVendas />
}

export default Dashboard
